<template>
<div class="container" v-if="isShowCompoment">
    <!-- <better-scroll class="footBtn" :scrollX="true" v-if="item.btns&&item.btns.length>0&&this.Btns.length>0"> -->
    <better-scroll class="footBtn" :scrollX="true" v-if="true">    
      <div class="wrapper">
        <span class="item changnative" @click="showBtns" v-show="sliderBtn.find(item => item.value)">
          <img src="../../../../assets/complaint/upTriangle.png" v-if="userInfo.unitType!=='enterprise'"/>
        </span>
        <!-- v-if="item1.value" -->
        <span class="item" v-for="(item1,index) in bottomBtn" :key="index" @click="goSlider1(item1)" v-if="item1&&item1.value">{{item1.label}}</span>
      </div>
    </better-scroll>
    <div class="btns" :class="{'btn_active':isshowBtns}" v-if="userInfo.unitType!=='enterprise'">
          <div v-if="userInfo.unitType!='enterprise'">
            <span class="travel line_d" v-for="(item,index) in sliderBtn" :key="index" @click="goBtn(item)" v-if="item&&item.value">{{item.label}}</span>
          </div>
    </div>
    <!-- 打开开关 showPopTravel-->
    <van-popup
      v-model="showPopTravel"
      position="bottom"
      class="showPopTravel"
      :style="{ height: '20%' }">
          <!-- <div class="contentTravel"> -->
            <!-- <div class="text"></div> -->
            <!-- <van-RadioGroup v-model="radio" class="radio">
                <van-Radio name="0">开</van-Radio>
                <van-Radio name="1">关</van-Radio>
            </van-RadioGroup> -->
          <!-- </div> -->
          <div class="content">{{'确定对 ('+item.mainComplainNumber+') 进补充证据?'}}</div>
          <div class="option">
              <div class="cancel" @click="showPopTravel=false">取消</div>
              <div class="comfirm" @click="addUp">确认</div>
          </div>
    </van-popup>
    <!-- 立案 -->
    <van-popup
      v-model="showPop1"
      class="record"
      position="bottom"
      :style="{ height: '20%' }">
          <div class="content">{{popContent1}}</div>
          <div class="option">
              <div class="cancel" @click="showPop1=false">取消</div>
              <div class="comfirm" @click="sureFilingBtn">确认</div>
          </div>
    </van-popup>
    <van-popup
      v-model="showPop"
      position="bottom"
      :style="{ height: '20%' }">
          <div class="content">{{popContent}}</div>
          <div class="option">
              <div class="cancel" @click="showPop=false">取消</div>
              <div class="comfirm" @click="getDisposeOperation">确认</div>
          </div>
    </van-popup>
    <van-popup
      class="folingPop"
      v-model="isShowFiling"
      position="bottom"
      :style="{ height: '25%' }"
    >
      <div>
        <p>{{'确定对投诉件 ('+item.mainComplainNumber+') 进行诉转案处理?'}} </p>
        <div class="filingBtnBox">
          <span class="cancelFiling" @click="cancelFilingBtn">取消</span>
          <span class="sureFiling" @click="sureFilingBtn1">确定</span>
        </div>
      </div>
    </van-popup>
    <!-- 撤回 -->
    <van-popup
      v-model="showPop2"
      position="bottom"
      :style="{ height: '20%' }">
          <div class="content">{{popContent1}}</div>
          <div class="option">
              <div class="cancel" @click="showPop2=false">取消</div>
              <div class="comfirm" @click="confirmCancel">确认</div>
          </div>
    </van-popup>
    <!-- 解绑电子合同 -->
    <van-popup
      class="folingPop"
      v-model="showPop3"
      position="bottom"
      :style="{ height: '25%' }"
    >
      <div>
        <p>{{'确定对 ('+item.mainComplainNumber+') 进行解绑电子合同?'}} </p>
        <div class="filingBtnBox">
          <span class="cancelFiling" @click="cancelElectContractBtn">取消</span>
          <span class="sureFiling" @click="sureElectContractBtn">确定</span>
        </div>
      </div>
    </van-popup>
</div>
</template>
<script>
    import util from '../../../../utils/common'
    import betterScroll from '../../../../components/base/betterScroll';
    import api from '../../../../service/modules/complaintApis';
    export default {
        components: {
            'better-scroll': betterScroll
        },
        data () {
            return {
                isShow: false,
                showPop3: false, // 解绑电子合同
                showPop2: false,
                isPersonShow: false, // 控制游客补充证据
                isShowEle: false,
                popContent1: '',
                showPop1: false,
                popContent: '',
                isShowFiling: false,
                showPop: false,
                detailInfo: '',
                ishow: false,
                ishow1: false,
                item: util.getJsonLocal('item'), // 上页面列表数据
                userInfo: this.$store.state.complaint.userInfo || util.getJsonLocal('userInfoComplaint'), // 用户信息
                isHandleWorkbench: this.$store.state.complaint.isHandleWorkbench || util.getJsonLocal('setWorkType'),
                Btns: [],
                isshowBtns: false,
                showPopTravel: false,
                radio: '0',
                isback: this.$store.state.complaint.isBackDetail || util.getJsonLocal('isBack'),
                btnList: [],
                sliderBtn:[],
                bottomBtn:[]
            }
        },
        mounted () {
        },
        created () {
            this.getBtnList();
        },
        computed: {
            formData: {
                get () {
                    return this.$store.state.complaint.basicImformation || {};
                },
                set (val) {
                    this.$store.state.complaint.basicImformation = val;
                }
            },
            isShowCompoment () {
                return this.bottomBtn.find(item => item.value) || this.sliderBtn.find(item => item.value);

            }
        },
        watch: {
            formData (val) {
                this.detailInfo = val;
                let obj = {
                    is_split: this.detailInfo.is_split
                }
                this.$store.commit('complaint/setWorkType', obj);
                if (util.getJsonLocal('item').btns && util.getJsonLocal('item').btns.length > 0) { // 有绑定合同的
                    this.Btns = util.getJsonLocal('item').btns;
                    this.Btns.map((item, index) => {
                        if (item.btnCode === 'B2014') {
                            this.isShowEle = true;
                        }
                        if (item.btnCode === 'B5006') {
                            this.isPersonShow = true;
                        }
                    })
                }
            }
        },
        methods: {
            getBtnList(){//获取按钮接口
                let params={
                    data: {
                        "mainComplainNumber": this.item.mainComplainNumber,
                        "complainNumber": this.item.complainNumber,
                        "subId": this.item.subId,
                        "pageType": (this.$route.query && this.$route.query.type === 'queryListItem') ? 'queryList' : util.getJsonLocal('buttonType')
                    }
                }
                api.worker.buttonPower(params).then(res=>{
                    if(res.ret==0){
                        const labelMap = {
                            finishBack:'办结反馈',//1
                            cancel: '撤案',//1
                            // mediateSuccess:'调解成功',
                            depFeedback:'处置反馈',//1
                            // forgive 换成 recall,
                            recall:'退回',//1
                            // recall:'退回12301',
                            revoke:'撤回',//1
                            distribution:'分发',//1
                            registerFail:'不予立案',//1
                            reject:'不予受理',//1
                            // travelOperation:'绑定旅行社',
                            complainToCase:'诉转案',//1
                            supplementMaterial:'补充办结材料',//1
                            // supplementInformation: '结果完善',
                            // guideOperation:'绑定导游',
                            informationCheck:'信息补充核实',//1
                            // mediateFail:'调解失败',
                            electronicContractBinding:'绑定电子合同',//1
                            forward:'转办',//1
                            evidenceSupplement:'游客补充证据',//1
                            centerFeedback:'处置反馈',//指挥中心反馈   结果反馈 -》 处置反馈//1
                            cancelAttention:'取消关注',//1
                            report:'上报',//1
                            supervise:'督办',//1
                            attention:'关注',//1
                            electronicContractUntied:'解绑电子合同',//1
                            informDepartment:'告知部门',//1
                            closeCase:'结案',//1
                            register:'立案',//1
                            appealVerify1: '申诉审核通过',//1
                            appealVerify2: '申诉审核不通过',//1
                            splitOrderReport1: '拆单审核通过',//1
                            splitOrderReport2: '拆单审核不通过',//1
                            reportIng1: '上报审核通过',//1
                            reportIng2: '上报审核不通过',//1
                        }
                        let sliderBtn;
                        let btns=res.data;
                        const mulBtnsProp = ['appealVerify', 'splitOrderReport', 'reportIng'];
                        Object.keys(res.data || {}).forEach(prop => {
                            // console.log(prop,'prop');
                            if (mulBtnsProp.indexOf(prop) === -1) {
                                btns[prop] = {
                                    type:prop,
                                    label: labelMap[prop] || '',
                                    value: btns[prop],
                                }
                                // console.log(btns,'btns');
                            } else {
                                btns[prop + 1] = {
                                    type:prop + 1,
                                    label: labelMap[prop + 1] || '',
                                    value: btns[prop],
                                }
                                btns[prop + 2] = {
                                    type:prop + 2,
                                    label: labelMap[prop + 2] || '',
                                    value: btns[prop],
                                }
                            }
                           
                        })
                        const {evidenceSupplement,electronicContractBinding,informationCheck,electronicContractUntied}=btns;//弹框中的按
                        this.sliderBtn=[evidenceSupplement,electronicContractBinding,informationCheck,electronicContractUntied];
                        //  mediateSuccess,mediateFail,forgive
                        const {depFeedback,recall,revoke,distribution,registerFail,complainToCase,supplementMaterial,reject,finishBack,
                        forward,centerFeedback,report,supervise,attention,cancelAttention,informDepartment,closeCase,register,cancel,appealVerify1, appealVerify2, splitOrderReport1, splitOrderReport2, reportIng1, reportIng2}=btns;//底部的按钮
                        this.bottomBtn=[report,distribution,centerFeedback,reject,finishBack,depFeedback,revoke,registerFail,complainToCase,supplementMaterial,
                        forward,supervise,attention,cancelAttention,informDepartment,closeCase,register,cancel, appealVerify1, appealVerify2,
                        splitOrderReport1, splitOrderReport2, reportIng1, reportIng2,recall];
                        console.log(this.sliderBtn,'this.sliderBtn');
                        console.log(this.bottomBtn,'this.bottomBtn');
                        if (util.getJsonLocal('buttonType') === 'superviseHandle') {
                            this.bottomBtn.push({
                                type: 'superviseToAcceptList',
                                label: '督办回复',
                                value: true,
                            })
                        }
                    }
                })
            },
            goSlider1(item){
                setTimeout(() => {
                    const value=item.type;
                    switch(value){
                        // case 'mediateSuccess'://调节成功
                        //     break;
                        case 'depFeedback'://部门反馈
                            this.$router.push('/complaint/processingEnd');
                            break;
                        case 'recall'://退回12301
                            this.$router.push('/complaint/return?dataItem=' + JSON.stringify(this.detailInfo));
                            // this.$router.push('/complaint/back12301');
                            break;
                        case 'revoke'://撤回
                            var orderNum = this.item.mainComplainNumber;
                            this.popContent1 = `确认投诉件(${orderNum})撤回？`;
                            this.showPop2 = true;
                            break;
                        case 'distribution'://分发
                            this.$router.push('/complaint/splitOrderDistribution?is_split=' + this.detailInfo.isSplit);
                            break;
                        case 'registerFail'://不予立案
                            this.$router.push('/complaint/dontFiling');
                            break;
                        case 'complainToCase'://诉转案
                            this.isShowFiling = true;
                            break;
                        case 'supplementMaterial'://补充办结材料
                            this.$router.push('/complaint/getThroughData');
                            break;
                        case 'finishBack': // 办结反馈
                            this.$router.push('/complaint/resultDetail?isShow=' + this.isShow);
                            break;    
                        // case 'supplementInformation': // 办结信息补充
                        //     this.$router.push('/complaint/resultDetail?isShow=' + this.isShow);
                        //     break;
                        // case 'mediateFail'://调解失败
                        //     break;
                        case 'forward'://转办
                            this.$store.commit('complaint/resetType', []);
                            this.$router.push('/complaint/transferSubordinate');
                            break;
                        case 'centerFeedback'://指挥中心反馈
                            this.$router.push('/complaint/feedback');
                            break;
                        case 'cancelAttention'://取消关注
                            this.getAttention('cancel');
                            break;
                        case 'report'://上报
                            this.$router.push('/complaint/escalationConfirmation');
                            break;
                        case 'supervise'://督办
                            this.$router.push('/complaint/supervise');
                            break;
                        case 'attention'://关注
                            this.getAttention('create');
                            break;
                        case 'informDepartment'://告知部门
                            this.$router.push('/complaint/tellCommand?is_split=' + this.detailInfo.isSplit);
                            break;
                        case 'closeCase'://结案
                            this.$router.push('/complaint/settleLawsuit');
                            break;
                        case 'register'://立案
                            this.popContent1 = `确认对投诉件“${this.item.mainComplainNumber}”立案处理？`
                            this.showPop1 = true;
                            break;
                        case 'cancel'://撤案
                            this.$router.push('/complaint/withdrawCase');
                            break;
                        case 'superviseToAcceptList': // 督办回复
                            this.$router.push('/complaint/supervisorReply');
                            break;
                        case 'appealVerify1': // 申诉审核通过
                            var orderNum = this.item.mainComplainNumber;
                            this.popContent = `确认投诉件(${orderNum})申诉通过？`;
                            this.showPop = true;
                            break;
                        case 'appealVerify2': // 申诉审核不通过
                            this.$router.push('/complaint/appealReviewFailed');
                            break;
                        case 'splitOrderReport1': // 拆单审核通过
                            this.$store.commit('complaint/resetType', []);
                            this.$router.push('/complaint/decommissioningPass');
                            break;
                        case 'splitOrderReport2': // 拆单审核不通过
                            this.$router.push('/complaint/failureopenOrder');
                            break;
                        case 'reportIng1': // 上报审核通过
                            this.$router.push('/complaint/examinationPassed');
                            break;
                        case 'reportIng2': // 上报审核不通过
                            this.$router.push('/complaint/escalationReview');
                            break;
                        case 'reject': // 不予受理
                            this.$router.push('/complaint/inadmissible');
                            break;
                    }
                }, 500)
            },
            goBtn(item){
                const value=item.type;
                console.log(value);
                switch(value){
                   case 'evidenceSupplement'://游客补充证据
                         this.showPopTravel = true;
                         break;
                   case 'guideOperation'://绑定导游
                         this.$router.push({
                            path: '/complaint/guideListQuery'
                        })
                         break;
                   case 'electronicContractBinding'://绑定电子合同
                        this.$router.push({
                            path: '/complaint/electronicContract',
                            query:{type:'bind'}
                        })
                         break;
                   case 'informationCheck'://补充信息核实
                        this.$router.push({
                            path: '/complaint/informationSupplement'
                        })
                         break;
                   case 'electronicContractUntied'://解绑电子合同
                        this.showPop3 = true;
                        break;                   
                }
            },
            sureFilingBtn1 () { // 诉转案确定
                let params = {
                    'mainComplainNumber': this.item.mainComplainNumber,
                    'complainNumber': this.item.complainNumber,
                    'subId': this.item.subId,
                }
                api.worker.signCase(params).then((res) => {
                    if (res.ret === 0) {
                        this.$Toast('操作成功');
                        this.isShowFiling = false;
                        this.getBtnList();
                        this.$emit('update');
                    }
                })
            },
            confirmCancel () {//撤回
                const params = {
                    // data:{
                    //     'subId': this.item.subId
                    // }
                    'subId': this.item.subId
                    
                }
                api.worker.revocation(params).then((res) => {
                    if (res.ret === 0) {
                        this.$Toast('操作成功');
                        this.getBtnList();
                        this.$emit('update');
                    }
                    this.showPop2 = false;
                })
            },
            sureElectContractBtn() {
                let params={
                    "mainComplainNumber": this.item.mainComplainNumber,
                    "type": 'unbind'
                }
                api.worker.operation(params).then(res=>{
                    if(res.ret==0){
                        this.getBtnList();
                        this.$Toast('解绑成功');
                        this.$emit('update');
                    }
                    this.showPop3 = false;
                })
            },
            cancelElectContractBtn() {
                this.showPop3 = !this.showPop3;
            },
            showBtns () {
                this.isshowBtns = !this.isshowBtns;
            },
            goTravl () {
                this.$router.push({
                    path: '/complaint/travelListQuery'
                })
            },
            goTravl1 () {
                this.$router.push({
                    path: '/complaint/unbundleTravle'
                })
            },
            goGuide () {
                this.$router.push({
                    path: '/complaint/guideListQuery'
                })

            },
            goGuide1 () {
                this.$router.push({
                    path: '/complaint/unbundleGuide'
                })
                console.log('item', this.item)
            },
            goEle () {
                this.$router.replace({
                    path: '/complaint/electronicContract'
                })
            },
            goinfo () {
                this.$router.push({
                    path: '/complaint/informationSupplement'
                })
            },
            getAttention (type) {
                let params={
                    mainComplainNumber: this.item.mainComplainNumber,
                    complainNumber: this.item.mainComplainNumber,
                    subId: this.item.subId,
                    type: type
                }
                api.worker.attention(params).then(res=>{
                     if (res.ret === 0) {
                         if (type === 'create') {
                             this.$Toast('关注成功');
                         }else {
                             this.$Toast('已成功取消关注');
                         }
                         this.getBtnList();
                        this.$emit('update');
                     }
                })
            },
            getDisposeOperation () {
                const data = {
                    'mainComplainNumber': this.item.mainComplainNumber,
                    'complainNumber': this.item.complainNumber,
                    'reportId': this.item.id,
                    'subId': this.item.subId
                }
                api.worker.appealVerifyAgree(data).then((res) => {
                    if (res.ret === 0) {
                        this.$Toast('操作成功');
                        this.showPop = false;
                        this.getBtnList();
                        // this.$emit('update');
                    }
                })
            },
            cancelFilingBtn () {
                this.isShowFiling = false
            },
            sureFilingBtn () {//立案
                let params = {
                    mainComplainNumber: this.item.mainComplainNumber,
                    complainNumber: this.item.complainNumber,
                    subId: this.item.subId,
                }
                api.worker.recordCase(params).then(res => {
                    if (res.ret === 0) {
                        this.showPop1 = false;
                        this.$Toast('操作成功');
                        this.getBtnList();
                        this.$emit('update');
                    }
                })
            },
            goTraPerson () {
                this.showPopTravel = true;
            },
            addUp () {
                let obj = {
                    mainComplainNumber: this.item.mainComplainNumber,
                    switchStatue: this.radio
                }
                api.worker.supplementEvidence(obj).then(res => {
                    if (res.ret === 0) {
                        this.$Toast('操作成功');
                        this.showPopTravel = false;
                        this.getBtnList();
                        this.$emit('update');
                    }
                })
            },
            unbundle () {
                let parms = {
                    type: 'boundList',
                    curPage: 1,
                    pageSize: 10,
                    orderNo: this.item.main_complain_number,
                    objType: 'guide'
                };
                api.guideAndTravelList(parms).then(res => {
                    if (res.ret === 0) {
                        if (res.data.list.length > 0) {
                            this.ishow = false
                        } else {
                            this.ishow = true
                        }
                    }
                });
            },
            unbundle1 () {
                let parms = {
                    type: 'boundList',
                    curPage: 1,
                    pageSize: 10,
                    orderNo: this.item.main_complain_number,
                    objType: 'travel'
                };
                api.guideAndTravelList(parms).then(res => {
                    if (res.ret === 0) {
                        if (res.data.list.length > 0) {
                            this.ishow1 = false
                        } else {
                            this.ishow1 = true
                        }
                        this.getBtnList();
                        this.$emit('update');
                    }
                });
            }
        }
    }
</script>
<style lang="less" scoped>
.container{
    width:100%;
     .footBtn {
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 50px;
        background-color: #fff;
        z-index: 9;
        // transform: translateY(0);
        transition: all 0.2s ease-in-out;
        box-shadow:0px -2px 8px 0px rgba(0,0,0,0.03);
        .wrapper {
            white-space: nowrap;
            position: absolute;
            padding-left:20px;
        .item {
            margin-top: 9px;
            display: inline-block;
            padding:0 21px;
            height: 30px;
            border: 1px solid @base-color;
            text-align: center;
            line-height: 32px;
            color: @base-color;
            margin-right: 10px;
            font-size: 14px;
            border-radius: 2px;
            img {
                display: inline-block;
                height: 15px;
                width: 15px;
                padding-top: 5px;
            }
        }
        .changnative{
            background-color: @base-color;
        }
        // .item:nth-child(1) {
        //     background-color: @base-color;
        // }
        }
    }
    .foot_active{
        //  transform: translateY(-100%);
        bottom: -50px!important;
    }
    .btns{
        width:100%;
        height:130px;
        background-color:#fff;
        position: fixed;
        left:0;
        bottom:-100%;
        z-index: 8;
        transition: all 0.5s ease-in-out;
        .travel{
            display: inline-block;
            padding:0px 20px;
            font-size:14px;
            color: #36b374;
            // border-right: 2px solid @base-color;
            margin-top:16px;
        }
        div {
            margin-top: 8px;
        }
    }
    .btn_active{
    bottom: 0!important;
    }
    .folingPop{
        padding: 30px 12px 0;
        >div{
        width: 100%;
        height: 100%;
        position: relative;

        >p{
            font-size: 16px;
            text-align: center;
            line-height: 28px;
            font-weight: bold;
            color: #333333;
        }

        .filingBtnBox{
            width: 100%;
            position: absolute;
            bottom: 10px;

            >span{
            padding: 0 5px;
            font-size: 15px;
            text-align: center;
            line-height: 40px;
            }

            .cancelFiling{
                float: left;
                color: #999999;
            }

            .sureFiling{
            float: right;
            color: #36B374;
            }
        }

        .filingBtnBox::after{
            content: '';
            display: block;
            clear: both;
        }
        }
    }
    .van-popup {
        padding: 20px 14px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .content {
            width: 100%;
            font-size: 16px;
            text-align: center;
            background-color: #fff;
            font-weight: bold;
            color: #333333;
            line-height: 28px;
        }
        .option {
            display: flex;
            justify-content: space-between;
            font-size: 14px;
            div {
                padding: 5px 7px;
            }
            .comfirm {
                color: #36B374;
            }
            .cancel {
                color: #999999;
            }
        }
    }
    .showPopTravel {
        .contentTravel {
            width: 100%;
            font-size: 16px;
            text-align: center;
            background-color: #fff;
            display: flex;
            padding: 20px 0px;
            .text {
                margin-right: 20px;
            }
            .radio {
                display: flex;
                justify-content: space-between;
            }
        }
    }
}
</style>
